const toggleItemSelection = ({selected, source, id, checked}) => {
    const index = selected.findIndex(item => item.id === id);

    if (~index) {
        if (!checked) {
            // remove the unchecked item
            return selected.filter(item => item.id !== id);
        }
    }
    else if (checked) {
        // add the checked item
        const item = source.find(i => i.id === id);
        return item ? [...selected, item] : [...selected];
    }

    return [...selected];
}

export {toggleItemSelection}